var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseIcn = function SvgCloseIcn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.37 8.5 6.36-6.36a.92.92 0 0 0 0-1.31l-.56-.56a.92.92 0 0 0-.66-.27c-.24 0-.48.1-.65.27L8.5 6.63 2.14.27A.92.92 0 0 0 1.5 0C1.24 0 1 .1.83.27L.27.83a.93.93 0 0 0 0 1.31L6.63 8.5.27 14.86a.92.92 0 0 0-.27.65c0 .25.1.49.27.66l.56.56c.17.17.4.27.66.27.25 0 .48-.1.65-.27l6.36-6.36 6.36 6.36a.92.92 0 0 0 1.32 0l.55-.56a.933.933 0 0 0 0-1.31L10.37 8.5z",
    fill: "#8497B8"
  })));
};
export default SvgCloseIcn;